export default defineNuxtPlugin(() => {
  return {
    provide: {
      locally: {
        getItem(itemName: string): any {
          if (import.meta.client) {
            const value = localStorage.getItem(itemName);

            if (value === null) {
              return null;
            }

            try {
              const parsedValue = JSON.parse(value);

              switch (value) {
                case 'true':
                  return true;
                case 'false':
                  return false;
                default:
                  return parsedValue;
              }
            } catch {
              return value;
            }
          }
        },

        setItem(itemName: string, value: any): void {
          if (import.meta.client) {
            const parsedValue = typeof value === 'string' ? value : JSON.stringify(value);
            localStorage.setItem(itemName, parsedValue);
          }
        },
      },
    },
  };
});
